import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const metricsService = {
  getAllMetrics
};

function getAllMetrics(params) {
  return apiCall("GET", apiUrls.metrics.base, null, params);
}
